module.exports = __webpack_public_path__ + "static/media/rukh.760e4a25.png";